import React, {useState} from "react";
import {CCol, CFormLabel, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import DatePicker from "react-date-picker";
import {applyFilter} from "../../store/slice/component/table";

const CreatedAtSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    let getDate = () => {
        if (data.created_at) {
            return new Date(data.created_at);
        }
        return '';
    };
    return <>
        <CRow className={'mb-1'}>
            <CCol>
                <CFormLabel>Entity Time Stamp</CFormLabel>
                <DatePicker
                    onChange={(e) => {
                        dispatch(applyFilter({
                            field_name: 'created_at',
                            value: e,
                        }));
                    }}
                    value={getDate() || ''}
                    className={'form-control'}
                />
            </CCol>
        </CRow>
    </>;
}

export default CreatedAtSearch;
